export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-19.6ca13c5e.png";